import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { InsiderNavigationLink } from 'site-modules/profile/components/shared/insider-navigation/shared/insider-navigation-link';
import { InsiderPageHeader } from 'site-modules/profile/components/shared/insider-page-header/insider-page-header';
import {
  INSIDER_NAVIGATION_MAP,
  INSIDER_NAVIGATION_TAB_NAMES,
  navigationFilter,
} from 'site-modules/profile/components/shared/insider-navigation/shared/insider-navigation-map';

export function InsiderNavigationDesktop({ slug, savedItemsAmount, contactedItemsAmount = 0 }) {
  const keys = Object.keys(INSIDER_NAVIGATION_MAP).filter(key => navigationFilter(key));
  const showItemsCount = slug === 'inventory';

  return (
    <Container className="insider-nav-header px-1 px-md-0_5 pt-1_5 pb-0_25">
      <InsiderPageHeader slug={slug} showItemsCount={false} />
      <Row className="insider-nav-header-links" tag="nav" aria-label="My Account">
        <Col
          tag="ul"
          xs={12}
          lg={10}
          className="nav-links d-flex flex-wrap justify-content-md-between list-unstyled mb-0 px-0_5"
        >
          {keys.map(tabKey => (
            <li key={tabKey}>
              <InsiderNavigationLink
                savedItemsAmount={savedItemsAmount[tabKey]}
                name={INSIDER_NAVIGATION_MAP[tabKey].tabName}
                link={`/insider/${tabKey}/`}
                classes={classnames(
                  'd-inline-block pb-0_5 text-decoration-none',
                  tabKey === slug
                    ? 'text-primary-darker insider-link-selected'
                    : 'text-gray-darker insider-link-unselected'
                )}
                selected={tabKey === slug}
                showNotification={tabKey === INSIDER_NAVIGATION_TAB_NAMES.INVENTORY}
              />
            </li>
          ))}
        </Col>
      </Row>
      {showItemsCount && savedItemsAmount[slug] > 0 && contactedItemsAmount > 0 && (
        <div className="saved-contacted-text text-gray-darker ms-0_5 mt-1">
          {savedItemsAmount[slug]} saved, {contactedItemsAmount} contacted
        </div>
      )}
    </Container>
  );
}

InsiderNavigationDesktop.propTypes = {
  slug: PropTypes.string.isRequired,
  savedItemsAmount: PropTypes.shape({}).isRequired,
  contactedItemsAmount: PropTypes.number,
};
